
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetokolhapurbusonrent() {



    const cardData =
    {
        keyword: 'Pune to Kolhapur Bus on Rent',
        heading: 'Amruta Travels: Pune to Kolhapur Bus on Rent',
        headingDescription: 'Amruta Travels offers Pune to Kolhapur Bus on Rent, providing a reliable and comfortable transportation solution for your journey. Whether you are planning a family trip, corporate event, or group tour, our well-maintained buses ensure a smooth and enjoyable ride to Kolhapur. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your travel to Kolhapur simple and stress-free. Choose from our range of buses, including 32-seater, 35-seater, 40-seater, and 45-seater options, to suit your group size. Book your Pune to Kolhapur Bus with Amruta Travels and embark on a journey of comfort and convenience!',


        top: 'Top Places to Visit in Kolhapur with Amruta Travels',
"topPlaces": [
  {
    "title": "Mahalaxmi Temple",
    "description": "A revered Shakti Peeth, the Mahalaxmi Temple is dedicated to Goddess Ambabai. Built in the 7th century, it showcases intricate carvings and is a significant pilgrimage site attracting devotees year-round."
  },
  {
    "title": "New Palace (Shri Chhatrapati Shahu Museum)",
    "description": "An architectural marvel from the 19th century, the New Palace houses the Shri Chhatrapati Shahu Museum. It displays royal artifacts, including weapons, costumes, and memorabilia of the Kolhapur rulers."
  },
  {
    "title": "Rankala Lake",
    "description": "A serene lake formed due to an earthquake in the 9th century. It's a popular spot for leisurely walks, boating, and enjoying local street food by the promenade."
  },
  {
    "title": "Panhala Fort",
    "description": "Perched atop the Sahyadri hills, Panhala Fort is steeped in Maratha history. It offers panoramic views and insights into the strategic military architecture of the era."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Situated on a hilltop, this temple complex is dedicated to Lord Jyotiba. It's especially vibrant during the annual fairs, drawing thousands of devotees."
  },
  {
    "title": "Siddhagiri Gramjivan Museum (Kaneri Math)",
    "description": "An open-air museum depicting rural life in Maharashtra through life-sized sculptures. It offers a glimpse into traditional village occupations and lifestyles."
  },
  {
    "title": "Radhanagari Wildlife Sanctuary",
    "description": "Also known as the 'Bison Sanctuary', it's home to the Indian bison and various other species. The sanctuary is a haven for nature enthusiasts and bird watchers."
  },
  {
    "title": "Temblai Hill Temple",
    "description": "Dedicated to Goddess Renuka Devi, this temple is located on a hill offering panoramic views of Kolhapur. It's associated with local legends and annual festivals."
  },
  {
    "title": "Khasbag Maidan",
    "description": "A historic wrestling arena where traditional Indian wrestling matches are held. It's a testament to Kolhapur's rich wrestling heritage."
  },
  {
    "title": "Bahubali Jain Temple, Kumbhoj",
    "description": "A significant Jain pilgrimage site featuring a 28-foot monolithic statue of Lord Bahubali. The temple complex is serene and spiritually enriching."
  }
],



  "services": [
    {
      "name": "Pune to Kolhapur Bus on Rent",
      "description": "Amruta Travels offers a variety of buses for rent for your journey from Pune to Kolhapur. Whether it's a religious trip to the Mahalaxmi Temple or a leisure visit to explore the city, our well-maintained buses are air-conditioned and designed for comfort. We ensure a smooth, enjoyable ride with experienced drivers to handle the journey, making your trip to Kolhapur safe and hassle-free."
    },
    {
      "name": "Pune to Kolhapur Mini Traveller on Rent",
      "description": "Our mini traveller rental service from Pune to Kolhapur is perfect for small groups, families, or friends who prefer a more intimate and comfortable travel experience. The vehicles are equipped with air-conditioning, plush seating, and ample space for luggage, making them ideal for both short and long journeys. Enjoy a relaxed trip with our professional and friendly drivers, who are well-versed in the best routes."
    },
    {
      "name": "Tempo Traveller on Rent in Pune for Kolhapur Trip",
      "description": "If you're looking for a spacious, comfortable, and air-conditioned vehicle for your trip from Pune to Kolhapur, Amruta Travels offers Tempo Travellers for rent. These vehicles are ideal for small to medium-sized groups and are equipped with modern amenities to ensure your comfort throughout the journey. Our reliable drivers will ensure a smooth and safe journey for your group to enjoy."
    },
    {
      "name": "Pune to Kolhapur Darshan Tempo Traveller on Rent",
      "description": "Take a religious journey to Kolhapur's Mahalaxmi Temple or other temples in the region with Amruta Travels' Tempo Traveller service. Our vehicles are designed for comfort, equipped with air-conditioning and spacious interiors for your convenience. We provide professional and knowledgeable drivers who will guide you safely on your religious trip, ensuring you experience the best of Kolhapur."
    },
    {
      "name": "14, 17, 20, 25 Seater Bus Pune to Kolhapur",
      "description": "For groups of varying sizes, Amruta Travels offers 14, 17, 20, and 25-seater buses for travel from Pune to Kolhapur. These buses are well-maintained, clean, and air-conditioned, ensuring a comfortable ride for all passengers. Whether you're planning a family trip, a religious visit, or a group outing, we have the right vehicle to suit your needs. Our experienced drivers will ensure timely travel while adhering to safety and comfort standards."
    },
    {
      "name": "32, 35, 40, 45 Seater Bus Hire from Pune Kolhapur",
      "description": "For larger groups traveling from Pune to Kolhapur, Amruta Travels offers buses with seating capacities ranging from 32 to 45 seats. These buses are perfect for corporate trips, large family gatherings, or organized tours. With air-conditioning, spacious interiors, and comfortable seating arrangements, our buses provide a relaxed journey to Kolhapur. We offer round-the-clock assistance and ensure your group’s comfort throughout the trip."
    },
    {
      "name": "Pune to Jyotirlinga Darshan Bus Tour Package",
      "description": "Amruta Travels offers a curated bus tour package for visiting the sacred Jyotirlingas across Maharashtra. Our buses are ideal for religious groups looking to embark on a spiritual journey to these divine temples. We provide well-maintained air-conditioned buses with enough space for your entire group, and our expert drivers will ensure a smooth and hassle-free trip. The tour covers all major Jyotirlinga temples, providing you with a serene and peaceful experience."
    },
    {
      "name": "Pune to Mahalaxmi Temple Darshan Bus Hire",
      "description": "Visit the famous Mahalaxmi Temple in Kolhapur with ease, thanks to Amruta Travels’ bus hire services. Whether it's for a family outing or a religious trip, we offer well-maintained, air-conditioned buses that cater to your needs. Our buses are equipped with comfortable seating, ample space for luggage, and our experienced drivers ensure a smooth journey. We guarantee timely arrival at the temple so you can have a peaceful and spiritual darshan experience."
    },
    {
      "name": "Pune to Kolhapur Mini Bus On Rent",
      "description": "For smaller groups heading to Kolhapur, Amruta Travels offers mini buses for rent. These buses are ideal for family trips, small religious tours, or corporate outings. Equipped with air-conditioning, plush seating, and spacious interiors, our mini buses are designed to offer maximum comfort. Our drivers are professional and ensure safe and smooth travel, making your trip to Kolhapur a pleasant experience."
    },
    {
      "name": "Pune to Kolhapur Full Bus on Rent",
      "description": "When you're looking for a full bus rental for your group trip to Kolhapur, Amruta Travels has you covered. Whether it's a religious trip to Mahalaxmi Temple or a family outing, our buses can accommodate large groups comfortably. With options for air-conditioning, ample legroom, and experienced drivers, we ensure your trip is comfortable, safe, and enjoyable. Our full bus services give you the flexibility to customize the trip to suit your needs."
    },
    {
      "name": "Pune to Balumama Temple Bus on Rent",
      "description": "Planning a trip to the Balumama Temple in Kolhapur? Amruta Travels provides comfortable buses for your group’s journey to this sacred site. Our buses are equipped with air-conditioning and ample space for your group, ensuring a peaceful and safe journey. Our expert drivers know the best routes, making sure you reach the temple on time and without any hassle."
    },
    {
      "name": "Pune to Admapur Bus Hire on Rent",
      "description": "For your journey from Pune to Admapur, Amruta Travels offers bus hire services that prioritize comfort and convenience. Whether you're planning a religious trip or a family gathering, our buses are air-conditioned, spacious, and well-maintained for a pleasant experience. Our professional drivers ensure safety and provide a smooth ride throughout the journey."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Bus on Rent", "Pune to Kolhapur Mini Traveller on Rent"],
    ["Tempo Traveller on Rent in Pune for Kolhapur Trip", "Pune to Kolhapur Darshan Tempo Traveller on Rent"],
    ["14, 17, 20, 25 Seater Bus Pune to Kolhapur", "32, 35, 40, 45 Seater Bus Hire from Pune Kolhapur"],
    ["Pune to Jyotirlinga Darshan Bus Tour Package", "Pune to Mahalaxmi Temple Darshan Bus Hire"],
    ["Pune to Kolhapur Mini Bus On Rent", "Pune to Kolhapur Full Bus on Rent"],
    ["Pune to Balumama Temple Bus on Rent", "Pune to Admapur Bus Hire on Rent"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Convenient Travel to Kolhapur",
    "WhyChoosedescription": "Amruta Travels offers Pune to Kolhapur Bus on Rent, ensuring a comfortable, stress-free journey to one of Maharashtra’s most renowned cities. Our buses are equipped with plush seating, generous legroom, and air conditioning to keep you relaxed during your ride. Whether you're heading for a spiritual trip to the Mahalakshmi Temple, exploring the local attractions, or attending an event, we guarantee a smooth and comfortable journey tailored to your needs."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimages, Group Outings, and Family Trips",
    "WhyChoosedescription": "Our buses are ideal for all types of group travel, whether it's a religious pilgrimage to Kolhapur’s sacred sites or a family outing to experience the region’s rich history and culture. The spacious seating and air-conditioning offer a pleasant ride for everyone. With ample space for luggage and personal belongings, we ensure that your group travels comfortably while making the most of your trip to Kolhapur."
  },
  {
    "WhyChooseheading": "Experienced and Safe Drivers",
    "WhyChoosedescription": "Safety is our priority. Our experienced drivers are not only familiar with the Pune to Kolhapur route but are also skilled in handling group transport with utmost care and professionalism. They are trained to navigate the roads safely, ensuring timely arrivals without compromising comfort. Their courteous behavior and deep knowledge of the area will make the journey pleasant and enjoyable, giving you peace of mind throughout the ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive rates for Pune to Kolhapur Bus on Rent, providing you with great value for your money. Our pricing is clear and upfront, with no hidden charges or surprises. You’ll know exactly what to expect, whether you're planning a one-day trip or a longer excursion. With affordable rates, you can ensure that your travel expenses are well within your budget while enjoying a premium travel experience."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "We take cleanliness and maintenance seriously. Our buses are regularly cleaned, sanitized, and maintained to the highest standards to ensure a hygienic and comfortable environment for your journey. Whether it's a short trip or a long-distance journey, you can count on our vehicles to provide a safe, well-kept environment that keeps you comfortable throughout your travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Options",
    "WhyChoosedescription": "We understand that every traveler has different needs. That's why we offer flexible pick-up and drop-off options throughout Pune, making it easy for your group to get to and from their preferred locations. Whether you’re traveling from your home, hotel, or office, we’ll tailor the schedule and pick-up points to suit your specific needs. Our aim is to provide maximum convenience and flexibility for your group."
  },
  {
    "WhyChooseheading": "Customizable Travel Itinerary",
    "WhyChoosedescription": "We offer fully customizable itineraries to ensure your trip to Kolhapur is exactly as you envision it. You can choose specific stops along the way, adjust travel times, and even plan your sightseeing. If you wish to extend your stay or include more locations on your route, we can easily adjust the itinerary. Our goal is to provide a personalized travel experience that accommodates all your preferences and requirements."
  },
  {
    "WhyChooseheading": "Simple Booking Process with Excellent Support",
    "WhyChoosedescription": "Booking a bus with Amruta Travels is incredibly easy and hassle-free. You can book online, call our customer service for assistance, or visit our office for direct support. Our friendly and professional staff is always ready to assist with any inquiries you may have, ensuring your booking process is as smooth and straightforward as possible. We're committed to providing full support throughout your journey, from the initial booking to the end of your trip."
  }
]






































    }

const faqData = [
  {
    question: 'How can I rent a bus for a trip from Pune to Kolhapur?',
    answer: 'Renting a bus for your trip from Pune to Kolhapur with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll assist you in selecting the right bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Kolhapur trip?',
    answer: 'We offer a variety of buses, including 32, 35, 45, and 50-seater options. Whether you prefer a standard or luxury bus, we have vehicles to suit your needs and ensure comfort and safety throughout the journey.',
  },
  {
    question: 'How long does it take to travel from Pune to Kolhapur?',
    answer: 'The travel time from Pune to Kolhapur is approximately 5 to 6 hours, depending on traffic conditions. Our experienced drivers will ensure a smooth and timely journey.',
  },
  {
    question: 'Are the buses comfortable for the long journey to Kolhapur?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors, ensuring a comfortable and enjoyable ride during your trip to Kolhapur.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Kolhapur?',
    answer: 'Yes, we offer flexible booking options for both one-day and multi-day trips to Kolhapur. We’ll tailor the itinerary to your needs to ensure a smooth and enjoyable trip.',
  },
  {
    question: 'Do you offer both standard and luxury buses for the Pune to Kolhapur trip?',
    answer: 'Yes, we offer both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and more, ensuring a high-end travel experience.',
  },
  {
    question: 'How much does it cost to rent a bus for Pune to Kolhapur?',
    answer: 'The cost depends on the bus size, trip duration, and any additional services you may require. Please contact us for a detailed quote based on your specific travel details.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. You can share your preferred locations with us, and we’ll plan the best route to suit your needs for the trip to Kolhapur.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Kolhapur bus rental?',
    answer: 'Amruta Travels offers reliable, comfortable, and timely bus services for your Pune to Kolhapur trip. Our buses are well-maintained, and our experienced drivers ensure a safe and smooth journey. We prioritize customer satisfaction and strive to make your trip hassle-free.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Desai',
    role: 'Corporate Travel Manager, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a corporate outing to Kolhapur. The bus was spacious, clean, and comfortable. The driver was courteous and made sure we had a safe and pleasant trip. Excellent service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Patel',
    role: 'Traveler, Pune',
    text: 'Our family booked a 35-seater bus for a day trip to Kolhapur. The bus was clean, air-conditioned, and well-maintained. The driver was friendly, and the journey was smooth and enjoyable. Highly recommend Amruta Travels for anyone planning a trip to Kolhapur!',
    rating: 5,
  },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-kolhapur-bus-on-rent.jpg",
  "description": "Book a bus for a comfortable and affordable trip from Pune to Kolhapur. Visit the famous Mahalaxmi Temple and other holy sites with Amruta Travels. Choose from a variety of buses including Mini Bus, Tempo Traveller, and larger coaches for group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4682"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-kolhapur-bus-on-rent"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Kolhapur Bus on Rent | Comfortable & Affordable Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a bus from Pune to Kolhapur for a comfortable and affordable journey. Visit Mahalaxmi Temple and other sacred sites. Choose from mini buses, tempo travellers, and larger buses for your trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokolhapurbusonrent;